var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8194 0.293923C12.089 0.646845 12.0526 1.17817 11.7381 1.48068L6 7L0.261919 1.48068C-0.0525742 1.17817 -0.0889959 0.646844 0.180571 0.293923C0.450136 -0.0589983 0.92361 -0.0998697 1.2381 0.202634L6 4.78299L10.7619 0.202635C11.0764 -0.0998696 11.5499 -0.0589982 11.8194 0.293923Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.c73f2c8dcccd64ba9cf12943de3d9b58.svg";
export { ForwardRef as ReactComponent };